/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import React from 'react';
import PropTypes, {
    array, func, object, string,
} from 'prop-types';
import { format } from 'date-fns';

// Material UI
import { withStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import Button from '@material-ui/core/Button';

const styles = (theme) => ({
    root: {
        textAlign: 'center',
        justifyContent: 'center',
    },
    rootToLeft: {
        justifyContent: 'flex-start',
    },
    monthWrapper: {
        display: 'inline-block',
    },
    monthBtn: {
        backgroundColor: '#fff',
        margin: '0 6px 12px',
        width: '84px',
        height: '72px',
        border: '1px solid #E9E9E9',
        textAlign: 'center',
        cursor: 'pointer',
        fontSize: '14px',
        lineHeight: '22px',
        fontWeight: '500',
        textTransform: 'capitalize',
        padding: '6px 10px',
        '&>span': {
            fontSize: '14px',
            [theme.breakpoints.down(500)]: {
                fontSize: '12px',
                lineHeight: '1.1em',
            },
        },
        '&:hover, &:visited, &:active, &:focus': {
            backgroundColor: '#DEEFE6 !important',
            border: '1px solid #044422',
        },
        [theme.breakpoints.down(626)]: {
            margin: '0 3px 6px',
        },
        [theme.breakpoints.down(500)]: {
            width: '78px',
            height: '60px',
            padding: '4px',
        },
    },
    selectedMonthBtn: {
        backgroundColor: '#DEEFE6 !important',
        border: '1px solid #044422',
        fontWeight: 'bold',
    },
});

const WeekDatedCalendarView = ({
    classes,
    isWeekActive,
    getSelectedWeekDetails,
    selectedDeliveryDate,
    weekDatedData,
}) => {
    let isAWeekAlreadySelected = 0;
    const showWeekCalendar = () => weekDatedData.map((data) => {
        const {
            date, month, year, calendarDateType, deliverySLA, weekOfCode,
        } = data;

        const fullDate = new Date(year, month, date);
        const newMonth = (`0${(fullDate.getMonth() + 1)}`).slice(-2);
        const newDay = (`0${fullDate.getDate()}`).slice(-2);
        const newYear = fullDate.getFullYear();
        const weekCurrentDate = [newYear, newMonth, newDay].join('-');
        const weeklyMonthlyName = format(fullDate, 'MMM. do');

        // Check delivery date or range start date match with the week
        let isSelectedWeek = isWeekActive === weekCurrentDate;
        if (!isSelectedWeek && selectedDeliveryDate?.rangeStartDate) {
            isSelectedWeek = weekCurrentDate === format(new Date(selectedDeliveryDate.rangeStartDate), 'yyyy-MM-dd');
        }

        if (isSelectedWeek) {
            isAWeekAlreadySelected += 1;
        }

        return (
            <div id="week-calendar-view" className={classes.monthWrapper}>
                <Button
                    key={`list-${month}`}
                    className={isSelectedWeek && isAWeekAlreadySelected < 2 ? `${classes.monthBtn} ${classes.selectedMonthBtn}` : classes.monthBtn}
                    onClick={() => getSelectedWeekDetails(weekCurrentDate, calendarDateType, deliverySLA, weekOfCode)}
                > {weeklyMonthlyName}<br />{year}
                </Button>
            </div>
        );
    });

    return (
        <Grid container className={`${classes.root} ${weekDatedData?.length < 6 ? classes.rootToLeft : ''}`}>
            {showWeekCalendar()}
        </Grid>
    );
};

WeekDatedCalendarView.propTypes = {
    classes: object.isRequired,
    isWeekActive: string.isRequired,
    getSelectedWeekDetails: func.isRequired,
    selectedDeliveryDate: object.isRequired,
    weekDatedData: array.isRequired,
};

export default withStyles(styles)(WeekDatedCalendarView);
